import React from 'react';
import { Field, FieldArray, reduxForm } from 'redux-form'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle, faInfoCircle, faPlus, faEdit } from '@fortawesome/free-solid-svg-icons';
import ReactLoading from 'react-loading';

import validate from './validate'
import { worktags } from '../Common/enum';

const INPUT_FIELDS = [
    {
        name: "type_code",
        label: "Type Code",
        identityField: true
    },
    {
        name: "bank_account",
        label: "Bank Account",
        identityField: true
    },
    {
        name: "matchBankAccountOnly",
        label: "Process Rule on Bank Account Only?",
        identityField: true
    },
    {
        name: "customer_ref",
        label: "Customer Reference",
        identityField: true
    },

    {
        name: "orig_id",
        label: "Orig ID",
        identityField: true
    },
    {
        name: "ind_id_no",
        label: "Individual ID Number",
        identityField: true
    },
    {
        name: "bo_customer",
        label: "B/O Customer",
        identityField: true
    },
    {
        name: "vrn",
        label: "Virtual Reference Number",
        identityField: true
    },
    {
        name: "area",
        label: "Area",
        identityField: false
    },
    {
        name: "description",
        label: "Description",
        identityField: false
    }
];

let isIdentityValue = (name) => {
    let identityNames = INPUT_FIELDS.map(field => {
        return field.identityField && field.name;
    });
    return identityNames.includes(name);
}

const RowWrapper = ({ children }) => (
    <div style={{
        "display": "flex",
        // "justify-content": "center",
        // "align-items": "center"
    }}>
        {children}
    </div>
);


const renderInput = ({ input, label, type, upperClass, lowerClass, disabled, meta: { touched, error } }) => (
    <div className={upperClass}>
        <div className={lowerClass}>
            {label && <label htmlFor={input.name}>{label}</label>}
            <RowWrapper>
                <input {...input} type={type} placeholder={label} disabled={disabled} className={`${(type !== "checkbox" && "form-control")}  ${(touched && error && !disabled) && "is-invalid"}   `} />
                &nbsp;&nbsp;&nbsp;&nbsp;{type === "checkbox" && "Check for YES" }
            </RowWrapper>
            {touched && error && <span style={{ color: 'red' }}><FontAwesomeIcon icon={faExclamationCircle} size="sm" /> {error}</span>}
        </div>
    </div>
);

const renderSelect = ({ input, label, type, options, upperClass, lowerClass, meta: { touched, error } }) => (
    <div className={upperClass}>
        <div className={lowerClass}>
            <select {...input} type={type} className={`form-control ${(touched && error) && "is-invalid"}`}>
                <option />
                {
                    Object.keys(options).map(option =>
                        <option
                            key={option}
                            value={options[option]}
                        >
                            {option.replace(/[A-Z]/, c => ` ${c}`).replace(/^\w/, c => c.toUpperCase())}
                        </option>
                    )
                }
            </select>
            {touched && error && <span style={{ color: 'red' }}><FontAwesomeIcon icon={faExclamationCircle} size="sm" /> {error}</span>}
        </div>
    </div>
);

const renderComments = ({ input, upperClass, lowerClass, meta: { touched, error } }) => {
    return (
        <div>
            <div>Comments</div>
            <textarea {...input} placeholder="Type any additional comments here..." className={`col-4 form-control form-group mb-2 ${(touched && error) && "is-invalid"}`}></textarea>
        </div>);
}
const renderWorktags = ({ fields, meta: { error } }) => {
    return (
        <div>
            <div>Worktags</div>
            <ul style={{ listStyleType: "none", padding: 0 }}>{/*Should extract this style*/}
                <li className="mb-2">
                    <button className="btn btn-info" type="button" onClick={() => fields.push({})}>Add Worktag</button>
                </li>
                {fields.map((worktag, index) =>
                    <li key={index}>
                        <div className="form-inline">
                            <Field
                                upperClass=""
                                lowerClass="form-group mb-2"
                                name={`${worktag}.key`}
                                component={renderSelect}
                                type="text"
                                options={worktags}
                            />
                            <Field
                                upperClass=""
                                lowerClass="form-group mx-sm-3 mb-2"
                                name={`${worktag}.value`}
                                component={renderInput}
                                type="text"
                            />
                            <button
                                className="btn btn-danger mb-2"
                                type="button"
                                title="Remove Worktag"
                                onClick={() => fields.remove(index)}
                            >-</button>
                        </div>
                    </li>
                )}
                {error && <li className="error"><span style={{ color: 'red' }}><FontAwesomeIcon icon={faExclamationCircle} size="sm" /> {error}</span></li>}
            </ul>
        </div>
    );
}

const createErrorText = (error) => {
    if (error.message.split(" ").includes("conditional")) {
        return 'Error: There is already a rule with the current identifiers (Type Code, Bank Account, Customer Reference, Orig ID, Individual ID Number and B/O Customer)';
    }
    return 'Error: There was a problem with the server. Please refresh the page and try again. Contact support if this continues to be a problem.';
}
const renderButtons = (props) => {
    const { handleSubmit, isEdit, onSubmit, submission, errorOnSubmit, invalidWorktags } = props;
    if (isEdit) {
        return (
            <div>
                <div className="row">
                    <button className="btn btn-warning ml-3 mr-2" onClick={handleSubmit}>
                        <FontAwesomeIcon icon={faEdit} size="sm" /> Update Rule
                    </button>
                    {!submission || (
                        <div>
                            <ReactLoading type={"spin"} color={"#666666"} height={'40px'} width={'40px'} />
                        </div>
                    )}
                </div>
                {invalidWorktags && (
                    <div className="row mt-2">
                        <div className="col-12 text-danger">
                            <div><FontAwesomeIcon icon={faExclamationCircle} size="sm" /> {"Invalid Worktags: " + Object.values(invalidWorktags).join(", ")} </div>
                        </div>
                    </div>
                )}
            </div>
        );
    } else {
        return (

            <div className="row">
                <button
                    className="btn btn-primary mr-2"
                    onClick={handleSubmit(values =>
                        onSubmit({
                            ...values,
                            button: "create"
                        })
                    )}
                    disabled={submission}
                >
                    <FontAwesomeIcon icon={faPlus} size="sm" /> Create and Add Another
                    </button>
                <button
                    className="btn btn-warning mr-2"
                    onClick={handleSubmit(values =>
                        onSubmit({
                            ...values,
                            button: "audit"
                        })
                    )}
                    disabled={submission}
                >
                    <FontAwesomeIcon icon={faInfoCircle} size="sm" /> Create and Review
                    </button>
                {!submission || (
                    <div>
                        <ReactLoading type={"spin"} color={"#666666"} height={'40px'} width={'40px'} />
                    </div>
                )}
                {errorOnSubmit && (
                    <div className="row mt-2">
                        <div className="col-12 text-danger">
                            <span><FontAwesomeIcon icon={faExclamationCircle} size="sm" /> {createErrorText(errorOnSubmit.response.data.error)} </span>

                        </div>
                    </div>
                )}
                {invalidWorktags && (
                    <div className="row mt-2">
                        <div className="col-12 text-danger">
                            <div className=""><FontAwesomeIcon icon={faExclamationCircle} size="sm" /> {"Invalid Worktags: " + Object.values(invalidWorktags).join(", ")} </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
};

const staticConstantType = (name) => {
    const listOfCheckboxes = ['matchBankAccountOnly'];
    return listOfCheckboxes.includes(name) ? 'checkbox' : 'string'
};

let RuleForm = props => {
    const { isEdit, initialValues } = props;
    console.log("RULEFORM:", props);
    return (
        <form>
            <div>
                {
                    INPUT_FIELDS.map((field, index) =>
                        <Field
                            key={index}
                            name={field.name}
                            label={field.label}
                            type={staticConstantType(field.name)}
                            component={renderInput}
                            upperClass="row center"
                            lowerClass="form-group col-4 "
                            disabled={isEdit && isIdentityValue(field.name) && (initialValues.usage_count || 0) > 0}
                        />
                    )
                }
            </div>
            <FieldArray name="worktags" component={renderWorktags} />
            <Field name="addComments" component={renderComments} />
            {renderButtons(props)}
        </form>
    )
}

RuleForm = reduxForm({
    form: 'rule',
    validate
})(RuleForm);

export default RuleForm;


// WEBPACK FOOTER //
// ./src/components/RuleForm/RuleForm.js